var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _g2, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 169,
    viewBox: "0 0 207 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7378 2.6084L30.1166 7.80574",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 3.89746L34.0255 6.5187",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5747 71.0146L44.9535 76.212",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6655 72.3027L48.8629 74.924",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.257 76.2998L197.636 81.4971",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.348 77.5889L201.545 80.2101",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51953 88.0312L2.89829 93.2286",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61035 89.3193L6.80769 91.9406",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M176.323 40.6416L170.502 40.6254",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M173.42 37.7227L173.404 43.5436",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7754 26.6602L64.1542 31.8575",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8657 27.9492L68.0631 30.5705",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.382 128.457L183.384 122.636",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.293 125.547L180.473 125.544",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.043 110.191L174.045 104.37",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M176.955 107.281L171.134 107.279",
    stroke: "#B3B3B3",
    strokeWidth: 0.806061
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.132 58.8589C134.523 54.3797 113.674 69.184 96.137 82.2886C82.5054 79.7021 62.5486 75.0768 50.7842 82.8455C50.1005 83.2897 54.5386 91.7595 55.1 92.5829C55.6613 93.4063 56.0233 93.8787 56.7895 94.1585L72.4971 99.8873L70.0303 101.725C69.1132 102.407 85.2381 126.53 85.8632 127.491L90.8816 137.513C91.2041 138.009 91.6989 138.329 92.2409 138.443C92.7408 138.547 93.2776 138.474 93.7512 138.198L90.6835 144.204L94.3578 152.335C94.8365 153.526 95.799 154.986 96.4984 155.398C96.6785 155.502 96.874 155.574 97.0799 155.617C97.6765 155.742 98.34 155.607 98.8468 155.276C110.449 147.615 118.773 135.459 121.861 121.832C140.808 110.833 155.861 90.3977 159.503 70.4952C159.707 69.3631 158.565 65.6765 157.457 63.9721L154.132 58.8589ZM129.847 99.0403C127.489 101.298 125.578 102.585 122.885 102.021C120.192 101.457 117.717 99.8609 116.098 97.3708C112.86 92.3863 114.25 85.6726 119.196 82.4027C124.147 79.1336 130.81 80.5296 134.052 85.515C137.293 90.5004 134.657 94.4358 129.847 99.0403Z",
    fill: "#B3B3B3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6835 144.204L94.3578 152.335C94.8365 153.526 95.799 154.986 96.4984 155.398C96.6785 155.502 96.874 155.574 97.0799 155.617C97.6765 155.742 98.34 155.607 98.8468 155.276C110.449 147.615 118.773 135.459 121.861 121.832C140.808 110.833 155.861 90.3977 159.503 70.4952C159.707 69.3631 158.565 65.6765 157.457 63.9721L154.132 58.8589C134.523 54.3797 113.674 69.184 96.137 82.2886C95.1839 82.1078 94.1999 81.917 93.1899 81.7211C79.7547 79.1159 61.726 75.62 50.7842 82.8455C50.1005 83.2897 54.5386 91.7595 55.1 92.5829C55.6613 93.4063 56.0233 93.8787 56.7895 94.1585L72.4971 99.8873L70.0303 101.725C70.0246 101.729 70.0196 101.734 70.0152 101.74C69.3738 102.621 82.5918 122.555 85.3731 126.75C85.6386 127.151 85.809 127.408 85.8632 127.491L90.8816 137.513C90.9377 137.599 90.9991 137.68 91.065 137.756C91.3778 138.114 91.7933 138.349 92.2409 138.443C92.7408 138.547 93.2776 138.474 93.7512 138.198L90.6835 144.204ZM92.8723 135.707L100.084 131.501L93.5577 144.278L96.7404 151.321L96.7609 151.372C96.923 151.775 97.1894 152.271 97.4797 152.694C97.545 152.789 97.6066 152.874 97.6633 152.947C108.572 145.649 116.414 134.143 119.335 121.253L119.584 120.153L120.558 119.588C138.885 108.949 153.407 89.1806 156.935 70.132C156.931 70.0928 156.923 69.9559 156.876 69.6924C156.804 69.2928 156.675 68.7801 156.499 68.2166C156.134 67.0442 155.656 65.9509 155.287 65.3833L152.55 61.1746C143.867 59.5114 134.74 61.8287 125.491 66.3139C115.887 70.9716 106.472 77.8052 97.6897 84.3677L96.7786 85.0485L95.66 84.8362C94.6896 84.6521 93.694 84.4592 92.6774 84.2622C86.4551 83.0564 79.4451 81.698 72.6052 81.2719C65.3639 80.8208 58.7613 81.4553 53.7448 84.1055C54.0258 84.7822 54.3975 85.5958 54.809 86.4517C55.3399 87.556 55.9108 88.6762 56.3821 89.5684C56.6178 90.0144 56.8247 90.3962 56.9861 90.6854C57.1361 90.954 57.2142 91.0837 57.234 91.1165C57.2382 91.1235 57.2398 91.1261 57.2387 91.1246C57.3756 91.3253 57.4721 91.4629 57.5543 91.5711C57.6177 91.6547 57.6581 91.7012 57.681 91.7258L77.8989 99.0996L73.1522 102.635C73.4437 103.177 73.8168 103.835 74.2622 104.593C75.6281 106.92 77.5549 109.995 79.5483 113.107C82.8211 118.216 86.1877 123.294 87.4929 125.263C87.782 125.699 87.9699 125.982 88.0334 126.08L88.1131 126.202L92.8723 135.707ZM71.5787 103.807L71.5797 103.806L71.5787 103.807ZM53.287 82.8374C53.2837 82.8213 53.285 82.8237 53.288 82.842C53.2876 82.8404 53.2873 82.8389 53.287 82.8374ZM113.928 98.7819L113.927 98.7808C109.913 92.6013 111.633 84.2919 117.765 80.238L117.766 80.2373C123.916 76.1765 132.195 77.911 136.222 84.1038C138.269 87.2517 138.561 90.3582 137.381 93.3718C136.302 96.1253 134.064 98.595 131.64 100.916C129.219 103.234 126.429 105.412 122.36 104.559C119.018 103.859 115.939 101.874 113.928 98.7819ZM116.098 97.3708C117.717 99.8609 120.192 101.457 122.885 102.021C125.578 102.585 127.489 101.298 129.847 99.0403C134.657 94.4358 137.293 90.5004 134.052 85.515C130.81 80.5296 124.147 79.1336 119.196 82.4027C114.25 85.6726 112.86 92.3863 116.098 97.3708Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_64030",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 57,
    width: 110,
    height: 98
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.034 81.9358L96.1937 81.9662L96.3238 81.869C105.088 75.3213 114.51 68.3432 124.183 63.5592C133.806 58.7995 143.633 56.2357 153.269 58.396L156.439 63.2686C156.976 64.0943 157.642 65.4294 158.147 66.7016C158.4 67.3364 158.609 67.9465 158.742 68.462C158.879 68.9945 158.92 69.3698 158.885 69.5665C155.28 89.3475 140.502 109.873 121.658 120.804L121.518 120.885L121.483 121.042C118.427 134.572 110.171 146.636 98.661 154.234C98.2332 154.513 97.6695 154.626 97.1729 154.522C97.0023 154.486 96.8446 154.427 96.7016 154.345C96.4267 154.182 96.0502 153.773 95.6678 153.216C95.2937 152.671 94.9465 152.032 94.7178 151.464L94.7149 151.456L94.7117 151.449L91.1066 143.48L94.0876 137.636L94.6618 136.511L93.5711 137.146C93.1798 137.375 92.7371 137.435 92.3234 137.348C91.8802 137.254 91.4768 136.995 91.21 136.595L86.1962 126.591L86.1868 126.572L86.1754 126.555C86.1199 126.469 85.9468 126.208 85.6776 125.803C84.4036 123.882 80.9768 118.716 77.6763 113.566C75.6781 110.448 73.7307 107.343 72.3409 104.976C71.6452 103.792 71.0935 102.799 70.7453 102.086C70.57 101.727 70.4531 101.452 70.3935 101.264C70.3839 101.234 70.3765 101.208 70.3708 101.186L72.7067 99.4465L73.2568 99.0369L72.611 98.8008L56.9062 93.0617C56.2615 92.8258 55.9565 92.4473 55.3957 91.625C55.1331 91.24 53.8936 88.9418 52.7963 86.6615C52.2499 85.5263 51.7467 84.4115 51.4232 83.5574C51.2606 83.1278 51.1493 82.7791 51.0981 82.5326C51.0806 82.4482 51.0723 82.3856 51.0694 82.3416C56.8342 78.5843 64.6181 77.81 72.7109 78.3202C79.7042 78.7611 86.8705 80.156 93.0827 81.3652C94.0933 81.562 95.0787 81.7538 96.034 81.9358ZM70.3533 101.086C70.3535 101.086 70.3537 101.09 70.3533 101.096C70.3529 101.089 70.3531 101.086 70.3533 101.086ZM70.243 101.281C70.2427 101.281 70.2424 101.281 70.2421 101.282L70.2423 101.282L70.243 101.281ZM51.0707 82.2722C51.0708 82.2724 51.0705 82.2753 51.0693 82.2803C51.0699 82.2744 51.0705 82.2719 51.0707 82.2722ZM50.9714 82.4059L50.9737 82.4043C50.973 82.4048 50.9722 82.4054 50.9714 82.4059ZM115.755 96.8667L115.755 96.8669C117.432 99.4438 119.993 101.097 122.778 101.683C125.563 102.268 128.565 101.785 131.12 100.098C136.235 96.7252 137.667 89.7816 134.312 84.6241C130.956 79.4649 124.064 78.0158 118.947 81.3934L118.947 81.3935C113.836 84.7709 112.404 91.7101 115.755 96.8667Z",
    fill: "#FF7E3B",
    stroke: "#E85300",
    strokeWidth: 0.740506
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_64030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2412 149.576L53.9891 153.81",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5161 153.083L54.7156 150.304",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0674 143.657L53.8152 147.891",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3413 147.163L54.5408 144.384",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5547 152.113L59.3026 156.348",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8291 155.619L60.0286 152.841",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9878 137.657L53.7357 141.891",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2627 141.164L54.4622 138.385",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4756 146.113L59.2235 150.348",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75 149.62L59.9495 146.841",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9634 154.569L64.7113 158.804",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8125 131.738L53.5604 135.973",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0874 135.245L54.2869 132.466",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3008 140.195L59.0486 144.429",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5757 143.701L59.7752 140.923",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7881 148.65L64.536 152.885",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.063 152.157L65.2625 149.379",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7344 125.739L53.4823 129.973",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0083 129.246L54.2078 126.467",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2217 134.194L58.9696 138.429",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4961 137.701L59.6956 134.923",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7095 142.65L64.4574 146.885",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9839 146.156L65.1834 143.378",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1973 151.106L69.9452 155.341",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4712 154.612L70.6707 151.834",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5596 119.82L53.3073 124.054",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.834 123.326L54.0335 120.548",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0469 128.276L58.7948 132.511",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3208 131.782L59.5203 129.004",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5347 136.731L64.2824 140.965",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8091 140.238L65.0086 137.46",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.022 145.188L69.7699 149.422",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2969 148.694L70.4965 145.916",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5098 153.644L75.2575 157.878",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7842 157.149L75.9837 154.371",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.481 113.82L53.2289 118.055",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7549 117.327L53.9544 114.549",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9678 122.276L58.7157 126.511",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2422 125.783L59.4417 123.005",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4556 130.731L64.2035 134.966",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7305 134.238L64.93 131.46",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9429 139.188L69.6908 143.422",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2178 142.693L70.4173 139.915",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4307 147.644L75.1786 151.878",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7051 151.15L75.9046 148.372",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3052 107.901L53.0531 112.136",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5801 111.408L53.7796 108.63",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.793 116.357L58.5407 120.591",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0674 119.863L59.2669 117.085",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2803 124.812L64.0282 129.047",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5547 128.319L64.7542 125.541",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7686 133.269L69.5163 137.503",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.043 136.774L70.2425 133.996",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2559 141.726L75.0038 145.96",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5303 145.231L75.7298 142.453",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7441 150.18L80.4919 154.414",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0186 153.687L81.2181 150.908",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2266 101.902L52.9745 106.136",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.501 105.408L53.7005 102.63",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7144 110.358L58.4623 114.593",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9883 113.864L59.1878 111.086",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2017 118.813L63.9496 123.048",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4766 122.319L64.6761 119.541",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.689 127.27L69.4369 131.504",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9639 130.775L70.1634 127.997",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1768 135.724L74.9247 139.958",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4512 139.231L75.6507 136.453",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6646 144.181L80.4125 148.415",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.939 147.687L81.1385 144.908",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1523 152.637L85.9001 156.871",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4268 156.143L86.6263 153.364",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0518 95.9824L52.7996 100.217",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3267 99.4893L53.5262 96.7106",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.54 104.439L58.288 108.674",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8145 107.945L59.014 105.167",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0269 112.894L63.7746 117.128",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3013 116.4L64.5008 113.622",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5146 121.35L69.2626 125.584",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7891 124.855L69.9886 122.077",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0024 129.806L74.7502 134.04",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2769 133.312L75.4763 130.534",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4902 138.262L80.2382 142.496",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7646 141.768L80.9642 138.989",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9775 146.718L85.7253 150.952",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.252 150.224L86.4515 147.445",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9727 89.9834L52.7208 94.2174",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2476 93.4893L53.4472 90.7105",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4604 98.4385L58.2086 102.672",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7349 101.945L58.9345 99.1666",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9478 106.896L63.6959 111.13",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2227 110.401L64.4223 107.623",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4351 115.351L69.1832 119.585",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71 118.856L69.9096 116.078",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9229 123.806L74.671 128.04",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1973 127.313L75.397 124.535",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4106 132.262L80.1588 136.496",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6851 135.768L80.8847 132.989",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 140.718L85.6466 144.952",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1729 144.224L86.3725 141.445",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3857 149.173L91.1337 153.407",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6606 152.68L91.8603 149.901",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7979 84.0645L52.5457 88.2986",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0723 87.5703L53.2716 84.7918",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2856 92.5195L58.0335 96.7537",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5601 96.0273L58.7597 93.2487",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7734 100.976L63.5214 105.21",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0483 104.481L64.2477 101.703",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2607 109.431L69.0085 113.665",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5352 112.938L69.7348 110.159",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.748 117.887L74.4959 122.121",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0229 121.394L75.2223 118.615",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2363 126.343L79.9841 130.577",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5103 129.849L80.7099 127.07",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7241 134.799L85.472 139.033",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9985 138.305L86.1979 135.526",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2119 143.254L90.9597 147.488",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4858 146.761L91.6855 143.982",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6987 151.71L96.4467 155.944",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9731 155.216L97.1725 152.437",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7192 78.0654L52.4671 82.2996",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9932 81.5703L53.1925 78.7918",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2061 86.5205L57.9539 90.7547",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.481 90.0264L58.6803 87.2478",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6938 94.9756L63.4417 99.2097",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9683 98.4824L64.1676 95.7039",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1816 103.433L68.9295 107.667",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4561 106.938L69.6554 104.16",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6694 111.888L74.4174 116.122",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9434 115.394L75.1428 112.615",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1562 120.343L79.9042 124.577",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4316 123.85L80.631 121.071",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6445 128.799L85.3924 133.033",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9185 132.306L86.1178 129.527",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1318 137.255L90.8797 141.489",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4067 140.761L91.6061 137.982",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6191 145.711L96.3669 149.945",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.894 149.217L97.0934 146.438",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1069 154.165L101.855 158.399",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5439 72.1465L52.2918 76.3806",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8188 75.6523L53.0182 72.8738",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0317 80.6006L57.7796 84.8347",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3062 84.1074L58.5055 81.3289",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5195 89.0566L63.2674 93.2908",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7939 92.5635L63.9933 89.785",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0068 97.5127L68.7548 101.747",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2822 101.019L69.4816 98.24",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4951 105.968L74.2429 110.202",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7695 109.475L74.9691 106.696",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9814 114.424L79.7293 118.658",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2563 117.931L80.4558 115.152",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4692 122.881L85.217 127.115",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7441 126.387L85.9435 123.608",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9575 131.335L90.7054 135.569",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2319 134.842L91.4313 132.063",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4453 139.792L96.1931 144.026",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7197 143.297L96.9193 140.518",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9321 148.247L101.68 152.481",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.207 151.753L102.406 148.974",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9531 74.6016L57.701 78.8357",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2275 78.1074L58.4269 75.3289",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4404 83.0566L63.1883 87.2908",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7148 86.5635L63.9142 83.785",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9277 91.5127L68.6756 95.7468",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2026 95.0195L69.402 92.241",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4155 99.9688L74.1634 104.203",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6899 103.475L74.8893 100.696",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9033 108.425L79.6512 112.659",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1782 111.931L80.3776 109.152",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3906 116.879L85.1385 121.113",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6655 120.387L85.8649 117.608",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8784 125.336L90.6263 129.57",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1528 128.842L91.3522 126.063",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3662 133.791L96.1141 138.025",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6406 137.298L96.84 134.519",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8535 142.247L101.601 146.481",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1284 145.754L102.328 142.975",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.341 150.703L107.089 154.937",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7783 68.6826L57.5262 72.9168",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0527 72.1895L58.2521 69.4109",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2656 77.1377L63.0135 81.3718",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.54 80.6436L63.7394 77.865",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7534 85.5947L68.5013 89.8289",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0283 89.1006L69.2277 86.3221",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2412 94.0498L73.9891 98.284",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5156 97.5566L74.715 94.7781",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.728 102.506L79.4758 106.74",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0024 106.012L80.202 103.233",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2158 110.961L84.9637 115.195",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4902 114.468L85.6896 111.689",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7041 119.417L90.4518 123.651",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.978 122.922L91.1774 120.143",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1914 127.873L95.9393 132.107",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4658 131.379L96.6652 128.6",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6787 136.328L101.426 140.562",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9526 139.835L102.152 137.056",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.167 144.784L106.914 149.018",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.441 148.29L107.64 145.512",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1865 71.1387L62.9344 75.3728",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4604 74.6455L63.6601 71.8668",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6743 79.5938L68.4222 83.8279",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9482 83.1006L69.1479 80.3219",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1616 88.0498L73.9095 92.284",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.436 91.5557L74.6357 88.777",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6494 96.5059L79.3973 100.74",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9238 100.012L80.1234 97.233",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1372 104.961L84.8852 109.195",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4111 108.469L85.6107 105.69",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6245 113.416L90.3724 117.65",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8989 116.924L91.0985 114.145",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1118 121.873L95.8597 126.107",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3867 125.379L96.5864 122.6",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5996 130.329L101.348 134.563",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.874 133.835L102.074 131.056",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.087 138.785L106.835 143.019",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.362 142.29L107.561 139.511",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.575 147.24L112.323 151.474",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0122 65.2197L62.7601 69.4539",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2866 68.7256L63.4862 65.9469",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 73.6748L68.2479 77.909",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7734 77.1816L68.973 74.403",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9878 82.1309L73.7357 86.365",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2622 85.6367L74.4618 82.858",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4751 90.5869L79.2231 94.8211",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7495 94.0938L79.9491 91.3151",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9624 99.042L84.7101 103.276",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2368 102.549L85.4364 99.7701",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4497 107.498L90.1976 111.732",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7241 111.004L90.9237 108.225",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.938 115.954L95.6857 120.188",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2119 119.46L96.4115 116.681",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4253 124.409L101.173 128.643",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6992 127.916L101.899 125.137",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.913 132.865L106.661 137.099",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.187 136.371L107.387 133.592",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 141.321L112.148 145.556",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.675 144.827L112.874 142.048",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4209 67.6758L68.1688 71.9099",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6948 71.1816L68.8944 68.403",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9082 76.1309L73.6561 80.365",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1826 79.6377L74.3822 76.859",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3955 84.5859L79.1433 88.8201",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6699 88.0938L79.8695 85.3151",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8833 93.043L84.6313 97.2772",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1577 96.5488L85.3573 93.7701",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3711 101.498L90.119 105.732",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6455 105.005L90.8451 102.226",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8579 109.954L95.6058 114.188",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1328 113.461L96.3324 110.682",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3457 118.409L101.094 122.643",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6206 121.916L101.82 119.137",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.833 126.866L106.581 131.1",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.108 130.372L107.308 127.593",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.322 135.321L112.07 139.556",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.596 138.828L112.795 136.049",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.809 143.776L117.556 148.011",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2461 61.7559L67.994 65.99",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.521 65.2627L68.7204 62.4842",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7334 70.2119L73.4813 74.4461",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0083 73.7178L74.2077 70.9393",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2212 78.668L78.9691 82.9021",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4961 82.1738L79.6954 79.3953",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.709 87.124L84.4569 91.3583",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9839 90.6299L85.1832 87.8514",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1958 95.5791L89.9435 99.8131",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4697 99.0859L90.6693 96.3073",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6836 104.035L95.4315 108.269",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.958 107.541L96.1574 104.762",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1714 112.49L100.919 116.724",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4463 115.998L101.646 113.22",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.659 120.946L106.407 125.181",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.934 124.452L107.133 121.674",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.146 129.402L111.894 133.636",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42 132.909L112.62 130.131",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.634 137.857L117.382 142.092",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.909 141.364L118.108 138.586",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6543 64.2129L73.4022 68.447",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9292 67.7188L74.1286 64.9402",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1416 72.668L78.8895 76.9021",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4165 76.1748L79.6159 73.3963",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6294 81.124L84.3773 85.3582",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9038 84.6299L85.1032 81.8514",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1167 89.5801L89.8646 93.8143",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3916 93.0859L90.591 90.3074",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6045 98.0352L95.3524 102.269",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8794 101.542L96.0787 98.7635",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0923 106.491L100.84 110.725",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3667 109.998L101.566 107.22",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58 114.946L106.328 119.181",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.854 118.453L107.054 115.675",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.068 123.402L111.816 127.637",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.342 126.909L112.541 124.131",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.555 131.858L117.303 136.092",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83 135.364L118.029 132.586",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.042 140.314L122.79 144.549",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.48 58.293L73.2279 62.5271",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7544 61.7998L73.954 59.0211",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9678 66.75L78.7157 70.9842",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2417 70.2549L79.4413 67.4762",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4551 75.2051L84.2029 79.4392",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7295 78.7119L84.9291 75.9333",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9429 83.6611L89.6908 87.8954",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2173 87.167L90.4169 84.3883",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4302 92.1172L95.1779 96.3512",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7046 95.623L95.9042 92.8444",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.918 100.571L100.666 104.806",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1924 104.077L101.392 101.298",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.406 109.028L106.154 113.262",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.68 112.534L106.879 109.755",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.893 117.484L111.641 121.719",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.167 120.989L112.367 118.211",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.381 125.939L117.129 130.173",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.655 129.446L117.855 126.668",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.868 134.395L122.616 138.629",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.143 137.901L123.342 135.123",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8882 60.749L78.636 64.9832",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1626 64.2559L79.3622 61.4772",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3755 69.2051L84.1234 73.4392",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6499 72.7119L84.8496 69.9332",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8633 77.6611L89.6111 81.8953",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1372 81.167L90.3368 78.3883",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3506 86.1172L95.0985 90.3514",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.625 89.623L95.8246 86.8444",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8379 94.5723L100.586 98.8065",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1128 98.0791L101.312 95.3004",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.326 103.028L106.074 107.263",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6 106.535L106.8 103.756",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.813 111.483L111.561 115.718",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.088 114.991L112.287 112.213",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.301 119.939L117.049 124.174",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.575 123.446L117.775 120.668",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.789 128.396L122.537 132.629",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.063 131.902L123.263 129.124",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.276 136.851L128.024 141.085",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7134 54.8311L78.4612 59.0652",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9883 58.3369L79.1879 55.5582",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2007 63.2861L83.9486 67.5203",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4751 66.792L84.6747 64.0133",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6885 71.7422L89.4363 75.9763",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9629 75.249L90.1625 72.4703",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1763 80.1982L94.9242 84.4325",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4512 83.7051L95.6508 80.9264",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6641 88.6533L100.412 92.8873",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.938 92.1592L101.138 89.3805",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.151 97.1094L105.899 101.344",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.426 100.615L106.625 97.8365",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.639 105.565L111.386 109.799",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.914 109.071L112.113 106.293",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.127 114.021L116.875 118.255",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4 117.527L117.6 114.749",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.615 122.477L122.362 126.711",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.889 125.982L123.088 123.204",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.102 130.932L127.849 135.166",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.376 134.438L128.576 131.66",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1221 57.2871L83.8699 61.5213",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3965 60.793L84.5961 58.0143",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6094 65.7412L89.3572 69.9754",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8843 69.249L90.0839 66.4703",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0967 74.1982L94.8445 78.4324",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3716 77.7041L95.5712 74.9254",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5845 82.6543L100.332 86.8885",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8594 86.1602L101.059 83.3815",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.072 91.1104L105.82 95.3446",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.347 94.6162L106.546 91.8375",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56 99.5654L111.308 103.8",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.834 103.071L112.034 100.293",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.047 108.021L116.795 112.255",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.322 111.527L117.522 108.749",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.535 116.478L122.283 120.712",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81 119.983L123.009 117.205",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.023 124.933L127.771 129.167",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.297 128.439L128.497 125.661",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.51 133.388L133.258 137.622",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4346 59.8232L89.1824 64.0574",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.709 63.3301L89.9086 60.5514",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9224 68.2783L94.6703 72.5125",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1968 71.7861L95.3964 69.0074",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4106 76.7354L100.159 80.9696",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6846 80.2422L100.884 77.4635",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.898 85.1914L105.646 89.4254",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.172 88.6963L106.372 85.9178",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.385 93.6465L111.133 97.8807",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.659 97.1523L111.859 94.3737",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.873 102.103L116.62 106.337",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.147 105.608L117.347 102.83",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.361 110.558L122.109 114.792",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.635 114.064L122.834 111.286",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.848 119.014L127.596 123.248",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.123 122.52L128.322 119.741",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.335 127.469L133.083 131.703",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61 130.976L133.809 128.197",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.356 53.8232L89.1038 58.0574",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6304 57.3301L89.83 54.5514",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8433 62.2783L94.5911 66.5125",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1177 65.7852L95.3173 63.0065",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3311 70.7354L100.079 74.9695",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6055 74.2412L100.805 71.4627",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.819 79.1904L105.567 83.4247",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.093 82.6963L106.293 79.9178",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.307 87.6465L111.055 91.8807",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.581 91.1523L111.781 88.3737",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.793 96.1016L116.541 100.336",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.068 99.6084L117.268 96.8297",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.281 104.558L122.029 108.792",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.556 108.064L122.755 105.286",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.77 113.014L127.517 117.248",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.043 116.521L128.243 113.742",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.257 121.47L133.005 125.704",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.531 124.976L133.731 122.197",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.744 129.925L138.492 134.159",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6689 56.3604L94.4168 60.5945",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9429 59.8672L95.1425 57.0885",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1567 64.8164L99.9046 69.0506",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4312 68.3223L100.631 65.5436",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.644 73.2725L105.392 77.5067",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.918 76.7783L106.118 73.9996",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.132 81.7266L110.88 85.9605",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.406 85.2344L111.606 82.4557",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.619 90.1826L116.367 94.4168",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.894 93.6895L117.093 90.9108",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.106 98.6387L121.854 102.873",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.381 102.145L122.581 99.3659",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.594 107.095L127.342 111.329",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.869 110.602L128.068 107.823",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.082 115.551L132.83 119.785",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.356 119.057L133.556 116.278",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.569 124.007L138.317 128.241",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.844 127.513L139.044 124.734",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0776 58.8164L99.8255 63.0506",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3521 62.3223L100.552 59.5436",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.565 67.2715L105.313 71.5056",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.84 70.7773L106.039 67.9987",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.053 75.7285L110.801 79.9627",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.328 79.2344L111.527 76.4557",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.541 84.1836L116.288 88.4178",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.815 87.6895L117.015 84.9108",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.028 92.6387L121.776 96.8729",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.302 96.1465L122.502 93.3678",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.516 101.095L127.264 105.329",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79 104.601L127.99 101.822",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.003 109.551L132.751 113.785",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.278 113.057L133.477 110.278",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.491 118.006L138.239 122.24",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.765 121.513L138.965 118.734",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.978 126.462L143.726 130.696",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9028 52.8975L99.6507 57.1316",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.39 61.3535L105.138 65.5877",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.665 64.8604L105.864 62.0817",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.878 69.8086L110.626 74.0428",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.152 73.3164L111.352 70.5377",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.366 78.2646L116.113 82.4986",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64 81.7705L116.84 78.9918",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.853 86.7197L121.6 90.954",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.127 90.2266L122.327 87.4479",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.341 95.1758L127.089 99.4098",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.615 98.6826L127.814 95.9039",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.828 103.633L132.576 107.867",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.103 107.139L133.302 104.36",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.316 112.088L138.064 116.322",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59 115.595L138.79 112.816",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.803 120.543L143.551 124.777",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.078 124.051L144.277 121.272",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.311 55.3535L105.059 59.5877",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.585 58.8604L105.785 56.0817",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.799 63.8086L110.547 68.0427",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.073 67.3154L111.272 64.5367",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.286 72.2656L116.034 76.4998",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56 75.7715L116.76 72.9928",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.774 80.7207L121.522 84.9549",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.048 84.2275L122.248 81.4489",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.261 89.1768L127.009 93.411",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.536 92.6826L127.735 89.9039",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.749 97.6309L132.497 101.865",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.023 101.138L133.223 98.359",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.237 106.088L137.985 110.322",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.51 109.595L138.71 106.816",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.724 114.543L143.472 118.777",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.999 118.05L144.198 115.271",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.212 122.999L148.96 127.233",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.624 57.8896L110.372 62.1238",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.899 61.3965L111.099 58.6178",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.112 66.3457L115.86 70.5799",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.386 69.8525L116.586 67.0739",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.599 74.8018L121.347 79.0357",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.873 78.3086L122.072 75.5299",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.086 83.2568L126.834 87.4911",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.361 86.7627L127.561 83.984",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.574 91.7139L132.321 95.9478",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.849 95.2197L133.048 92.441",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.062 100.168L137.81 104.402",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.336 103.676L138.536 100.897",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.55 108.625L143.298 112.859",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.824 112.131L144.023 109.352",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.037 117.08L148.785 121.314",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 120.586L149.512 117.807",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.033 60.3467L115.781 64.5808",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.307 63.8525L116.507 61.0739",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.52 68.8018L121.268 73.036",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.794 72.3076L121.994 69.5289",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.008 77.2578L126.756 81.492",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.282 80.7637L127.482 77.9852",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.495 85.7129L132.243 89.9471",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77 89.2197L132.969 86.4412",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.982 94.1689L137.73 98.4032",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.257 97.6758L138.457 94.8971",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47 102.625L143.218 106.859",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.744 106.132L143.944 103.353",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.958 111.08L148.706 115.314",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.232 114.588L149.432 111.809",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.446 119.536L154.194 123.77",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.858 54.4277L115.606 58.6619",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.132 57.9336L116.332 55.1549",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.346 62.8828L121.094 67.117",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.62 66.3896L121.82 63.611",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.833 71.3389L126.581 75.5728",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.107 74.8457L127.307 72.067",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.32 79.7939L132.068 84.0282",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.595 83.3008L132.794 80.5221",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.809 88.25L137.556 92.484",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.083 91.7568L138.282 88.9782",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.296 96.7061L143.044 100.94",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.57 100.212L143.769 97.4332",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.784 105.162L148.531 109.396",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.058 108.668L149.257 105.889",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.271 113.617L154.019 117.851",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.545 117.124L154.745 114.345",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.266 56.8838L121.014 61.1179",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.541 60.3887L121.74 57.61",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.754 65.3389L126.502 69.5731",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.028 68.8447L127.227 66.066",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.241 73.7949L131.989 78.0292",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.516 77.3018L132.716 74.5231",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.729 82.25L137.477 86.4842",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.003 85.7568L138.203 82.9782",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.216 90.7061L142.964 94.9403",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.491 94.2129L143.69 91.4342",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.705 99.1621L148.452 103.396",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.979 102.668L149.178 99.8893",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.192 107.618L153.94 111.852",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.466 111.124L154.666 108.345",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.679 116.073L159.427 120.307",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58 59.4199L126.328 63.6542",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.854 62.9268L127.053 60.1481",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.066 67.876L131.814 72.1099",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.34 71.3828L132.54 68.6041",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.554 76.3311L137.302 80.5653",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.829 79.8379L138.028 77.0592",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.042 84.7871L142.789 89.0211",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.316 88.293L143.516 85.5143",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.529 93.2432L148.277 97.4774",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.804 96.75L149.003 93.9713",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.017 101.699L153.765 105.933",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.291 105.205L154.491 102.426",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.504 110.154L159.252 114.389",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.779 113.661L159.978 110.882",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5 53.4209L126.248 57.655",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.988 61.875L131.736 66.1092",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.262 65.3828L132.462 62.6041",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.475 70.332L137.223 74.5662",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75 73.8379L137.95 71.0592",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.963 78.7871L142.711 83.0213",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.237 82.2939L143.437 79.5153",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.451 87.2432L148.199 91.4774",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.725 90.75L148.924 87.9713",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.938 95.6992L153.686 99.9334",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.213 99.2051L154.412 96.4264",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.426 104.155L159.174 108.389",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7 107.661L159.9 104.882",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.813 55.957L131.561 60.1913",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.088 59.4639L132.287 56.6852",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3 64.4131L137.048 68.6471",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.575 67.918L137.774 65.1393",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.789 72.8682L142.536 77.1024",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.062 76.375L143.262 73.5963",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.276 81.3232L148.024 85.5572",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.55 84.8311L148.75 82.0524",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.764 89.7803L153.512 94.0145",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.038 93.2861L154.237 90.5075",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.25 98.2363L158.998 102.47",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.525 101.742L159.724 98.9635",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.221 58.4131L136.969 62.6473",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.496 61.9189L137.695 59.1404",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.709 66.8691L142.457 71.1034",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.984 70.375L143.184 67.5963",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.196 75.3242L147.944 79.5584",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.471 78.8311L148.671 76.0524",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.684 83.7803L153.432 88.0145",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.959 87.2861L154.158 84.5076",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.172 92.2363L158.92 96.4706",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.446 95.7432L159.646 92.9647",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.534 60.9502L142.282 65.1842",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.809 64.4561L143.008 61.6775",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.022 69.4043L147.77 73.6385",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.296 72.9121L148.496 70.1336",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.51 77.8604L153.258 82.0943",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.784 81.3672L153.984 78.5887",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.997 86.3174L158.745 90.5516",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.271 89.8232L159.471 87.0447",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.456 54.9502L142.204 59.1844",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73 58.4561L142.93 55.6775",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.943 63.4053L147.691 67.6395",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.218 66.9121L148.417 64.1336",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.431 71.8613L153.179 76.0955",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.706 75.3682L153.905 72.5897",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.918 80.3164L158.666 84.5506",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.193 83.8232L159.392 81.0447",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.769 57.4863L147.516 61.7203",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.042 60.9941L148.242 58.2156",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.256 65.9424L153.004 70.1766",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.531 69.4482L153.73 66.6697",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.744 74.3984L158.491 78.6324",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.019 77.9043L159.218 75.1258",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.177 59.9424L152.925 64.1766",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.452 63.4492L153.651 60.6705",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.664 68.3984L158.412 72.6327",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.938 71.9053L159.138 69.1266",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.002 54.0244L152.75 58.2584",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.276 57.5303L153.476 54.7516",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.49 62.4785L158.238 66.7127",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.764 65.9854L158.964 63.2067",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.411 56.4805L158.159 60.7147",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.685 59.9873L158.885 57.2086",
    stroke: "#808080",
    strokeWidth: 0.592405
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M152.566 57.7856C132.992 53.3134 108.437 58.9966 90.922 72.1233C77.3145 69.5422 62.9547 72.3919 51.2056 80.1744C50.5228 80.6194 50.1469 81.4204 50.2364 82.235C50.3293 83.0547 50.8686 83.7469 51.6333 84.0265L67.3116 89.7517L64.8479 91.592C63.9319 92.2755 63.7056 93.5589 64.3291 94.5208L85.6444 127.402C85.9661 127.898 86.4599 128.218 87.0009 128.331C87.4999 128.436 88.0358 128.363 88.5088 128.086L91.1615 126.537L90.0958 143.353C90.0441 144.174 90.5438 144.888 91.2418 145.3C91.4216 145.404 91.6167 145.476 91.8222 145.519C92.4177 145.644 93.0802 145.508 93.5864 145.177C105.173 137.502 113.49 125.33 116.581 111.689C135.503 100.669 150.542 80.206 154.189 60.2831C154.393 59.1498 153.68 58.0499 152.566 57.7856ZM125.67 90.3149C123.2 91.9506 120.302 92.4223 117.614 91.8591C114.926 91.2959 112.456 89.6996 110.841 87.2081C107.612 82.2208 109.003 75.5002 113.943 72.2244C118.887 68.9495 125.538 70.343 128.772 75.3312C132.005 80.3193 130.613 87.0442 125.67 90.3149Z",
    fill: "#E0E0E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5658 74.8836L90.4451 74.671C77.7672 72.2662 64.3875 74.8176 53.3299 81.8878L72.7039 88.9626L66.7123 93.4382L87.5775 125.625L94.0551 121.843L92.7384 142.62C103.457 135.299 111.161 123.882 114.055 111.11L114.303 110.012L115.275 109.447C133.482 98.8431 147.937 79.1971 151.565 60.2171C132.87 56.1104 109.315 61.5813 92.4776 74.2002L91.5658 74.8836ZM154.189 60.2831C150.542 80.206 135.503 100.669 116.581 111.689C113.49 125.33 105.173 137.502 93.5864 145.177C93.0802 145.508 92.4177 145.644 91.8222 145.519C91.6167 145.476 91.4216 145.404 91.2418 145.3C90.5438 144.888 90.0441 144.174 90.0958 143.353L91.1615 126.537L88.5088 128.086C88.4945 128.094 88.4801 128.102 88.4657 128.11C88.0035 128.367 87.4848 128.433 87.0009 128.331C86.4599 128.218 85.9661 127.898 85.6444 127.402L64.3291 94.5208C63.7093 93.5647 63.9292 92.2908 64.8316 91.6043C64.837 91.6002 64.8424 91.5961 64.8479 91.592L67.3116 89.7517L51.6333 84.0265C50.8686 83.7469 50.3293 83.0547 50.2364 82.235C50.1469 81.4204 50.5228 80.6194 51.2056 80.1744C62.9547 72.3919 77.3145 69.5422 90.922 72.1233C108.437 58.9966 132.992 53.3134 152.566 57.7856C153.68 58.0499 154.393 59.1498 154.189 60.2831ZM108.669 88.6162L108.668 88.6151C104.666 82.4341 106.387 74.1216 112.509 70.0618L112.51 70.0611C118.654 65.9911 126.925 67.724 130.944 73.9231C134.951 80.1048 133.23 88.4239 127.102 92.479C124.035 94.51 120.428 95.0966 117.089 94.397C113.75 93.6974 110.675 91.7108 108.669 88.6162ZM125.67 90.3149C123.2 91.9506 120.302 92.4223 117.614 91.8591C114.926 91.2959 112.456 89.6996 110.841 87.2081C107.612 82.2208 109.003 75.5002 113.943 72.2244C118.887 68.9495 125.538 70.343 128.772 75.3312C132.005 80.3193 130.613 87.0442 125.67 90.3149Z",
    fill: "#808080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9881 132.504C51.2578 138.832 47.2087 157.393 47.7695 159.793C47.949 160.566 57.4762 163.869 58.2433 164.074C58.8126 164.223 59.4019 164.137 59.8962 163.852C60.0774 163.747 60.2434 163.616 60.3944 163.459C62.1049 161.655 77.1791 145.636 78.9094 139.308C80.8581 132.181 75.9301 125.997 69.483 122.981C67.2961 121.958 60.2313 118.466 58.2509 118.879C53.4202 119.888 54.3717 127.452 52.9881 132.504Z",
    fill: "#B3B3B3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3487 158.356C50.3795 158.37 50.4111 158.384 50.4435 158.399C51.299 158.786 52.4707 159.255 53.7049 159.723C54.9294 160.188 56.1758 160.636 57.1627 160.98C57.656 161.153 58.0798 161.297 58.3998 161.404C58.5084 161.44 58.603 161.471 58.6829 161.497C59.8146 160.299 63.738 156.103 67.6562 151.417C69.7319 148.935 71.7778 146.348 73.3993 144.017C75.0806 141.6 76.1058 139.734 76.4094 138.624C77.8783 133.252 74.2818 128.087 68.3848 125.328C68.1642 125.225 67.9036 125.102 67.6107 124.963C66.3823 124.38 64.5864 123.528 62.7961 122.785C61.6882 122.325 60.6501 121.936 59.8063 121.689C59.3838 121.566 59.059 121.492 58.829 121.458C58.7618 121.448 58.713 121.443 58.6804 121.44C58.0005 121.623 57.3646 122.245 56.8666 124.692C56.6581 125.717 56.5204 126.827 56.3673 128.06C56.3409 128.273 56.314 128.49 56.2863 128.71C56.1062 130.139 55.8882 131.727 55.4881 133.188M58.2433 164.074C57.4762 163.869 47.949 160.566 47.7695 159.793C47.2087 157.393 51.2578 138.832 52.9881 132.504C53.3844 131.057 53.5891 129.405 53.793 127.759C54.301 123.658 54.8037 119.599 58.2509 118.879C60.0454 118.504 66.0144 121.336 68.7463 122.633C69.0294 122.767 69.2777 122.885 69.483 122.981C75.9301 125.997 80.8581 132.181 78.9094 139.308C77.1791 145.636 62.1049 161.655 60.3944 163.459C60.2434 163.616 60.0774 163.747 59.8962 163.852C59.4019 164.137 58.8126 164.223 58.2433 164.074ZM50.3487 158.356C50.4036 157.696 50.5116 156.83 50.6679 155.793C50.9865 153.677 51.4846 150.982 52.06 148.135C53.212 142.436 54.6436 136.276 55.4878 133.189",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_317_64030",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 118,
    width: 33,
    height: 47
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.147 132.469L52.5046 132.565C52.5046 132.565 52.5046 132.565 52.5046 132.565M52.147 132.469L47.3786 159.857M52.147 132.469L52.5046 132.565M52.147 132.469L52.5046 132.565M52.5046 132.565C52.8539 131.263 53.0508 129.807 53.2259 128.36C53.2516 128.148 53.2768 127.936 53.302 127.724C53.4493 126.485 53.5942 125.267 53.8173 124.141C54.3447 121.48 55.2678 119.551 57.4456 119.103C57.6301 119.065 57.9074 119.069 58.28 119.126C58.6464 119.183 59.0783 119.288 59.5592 119.431C60.5208 119.718 61.6505 120.151 62.7959 120.633C64.6551 121.415 66.5304 122.316 67.7632 122.908C68.0495 123.045 68.3011 123.166 68.5099 123.265C74.9195 126.301 79.7077 132.421 77.8494 139.356C77.4402 140.883 76.2124 143.04 74.5333 145.474C72.8626 147.896 70.7735 150.554 68.68 153.075C64.495 158.114 60.3088 162.584 59.4538 163.491M59.4538 163.491C59.3265 163.624 59.1881 163.733 59.0387 163.819C58.6279 164.057 58.1379 164.127 57.6618 164M59.4538 163.491C59.4535 163.492 59.4532 163.492 59.4529 163.492L59.7223 163.746L59.4548 163.49C59.4545 163.491 59.4542 163.491 59.4538 163.491ZM57.6618 164C57.2954 163.9 54.7253 163.01 52.2093 162.042C50.9542 161.559 49.7237 161.06 48.7981 160.636C48.334 160.423 47.9557 160.232 47.6916 160.075C47.5586 159.996 47.4652 159.931 47.4067 159.882C47.3948 159.872 47.3855 159.864 47.3786 159.857M57.6618 164C57.6615 163.999 57.6612 163.999 57.6609 163.999L57.565 164.357L57.6622 164C57.6621 164 57.6619 164 57.6618 164ZM47.3786 159.857C47.3817 159.874 47.385 159.89 47.3886 159.905C47.3797 159.867 47.3656 159.845 47.3613 159.839C47.3635 159.842 47.3689 159.848 47.3786 159.857Z",
    fill: "#FFBA07",
    stroke: "#D68100",
    strokeWidth: 0.740506
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_317_64030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8213 162.414L47.7569 163.737",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4849 168.184L55.8074 163.248",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.583 160.595L53.5189 161.917",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3901 163.725L51.7127 158.789",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4399 163.236L63.3758 164.559",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2466 166.366L61.5692 161.43",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1035 169.007L71.4261 164.071",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4688 156.262L49.4044 157.584",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2764 159.391L47.599 154.455",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3262 158.902L59.2621 160.225",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1328 162.032L57.4554 157.096",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1836 161.544L69.1192 162.866",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9902 164.674L67.3128 159.738",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0405 164.185L78.9764 165.507",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8472 167.314L77.1697 162.379",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2314 154.444L55.1674 155.767",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0381 157.573L53.3607 152.637",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0879 157.085L65.0238 158.408",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8955 160.215L63.2181 155.279",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9443 159.726L74.8803 161.048",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7515 162.855L73.074 157.92",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 150.11L51.0533 151.433",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9243 153.24L49.2469 148.304",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9741 152.752L60.91 154.075",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7812 155.88L59.1037 150.944",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.832 155.394L70.7676 156.716",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6392 158.521L68.9617 153.586",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6885 158.034L80.6244 159.357",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4956 161.162L78.8181 156.226",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0229 145.652L46.9589 146.975",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8789 148.292L56.8148 149.615",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6865 151.422L55.009 146.486",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7363 150.934L66.6722 152.256",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5435 154.062L64.8659 149.127",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5933 153.574L76.5292 154.897",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3999 156.704L74.7224 151.768",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7661 143.959L52.7017 145.281",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5728 147.088L50.8953 142.152",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6226 146.6L62.5585 147.922",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4292 149.729L60.7518 144.793",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.48 149.241L72.4156 150.564",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2866 152.37L70.6092 147.434",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3374 151.883L82.2733 153.205",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6709 139.5L48.6068 140.823",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4775 142.63L46.8001 137.694",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5278 142.142L58.4637 143.464",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.335 145.271L56.6575 140.335",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3843 144.782L68.3202 146.105",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1914 147.912L66.514 142.976",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2412 147.424L78.1771 148.746",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0488 150.553L76.3714 145.617",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4141 137.808L54.3497 139.13",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2207 140.937L52.5433 136.001",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.271 140.448L64.2069 141.771",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0776 143.578L62.4002 138.642",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1284 143.091L74.064 144.413",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9351 146.219L72.2576 141.283",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3193 133.349L50.2552 134.671",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.126 136.478L48.4486 131.542",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1768 135.99L60.1127 137.313",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9834 139.119L58.306 134.183",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0327 138.631L69.9686 139.953",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8394 141.759L68.1619 136.823",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8901 141.272L79.826 142.595",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6968 144.4L78.0194 139.464",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.063 131.656L55.9986 132.979",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8691 134.785L54.1916 129.85",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9189 134.298L65.8549 135.62",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7261 137.427L64.0487 132.491",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7769 136.938L75.7125 138.261",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.583 140.067L73.9056 135.131",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9673 127.196L51.9032 128.519",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7739 130.326L50.0964 125.391",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8242 129.838L61.7601 131.16",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6313 132.967L59.9539 128.031",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6812 132.479L71.6171 133.802",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4883 135.608L69.8109 130.672",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5381 135.12L81.474 136.443",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3452 138.249L79.6677 133.313",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.854 122.863L47.7899 124.186",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7104 125.504L57.6461 126.826",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5176 128.634L55.8401 123.698",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5674 128.146L67.5033 129.468",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.374 131.274L65.6966 126.339",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4248 130.787L77.3605 132.11",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2314 133.915L75.554 128.979",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6162 121.046L53.5521 122.368",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4224 124.174L51.7449 119.238",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4731 123.687L63.409 125.009",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2798 126.815L61.6023 121.88",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3296 126.327L73.2655 127.65",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1367 129.457L71.4593 124.521",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.186 128.969L83.122 130.291",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3096 119.842L47.6322 114.906",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3594 119.354L59.295 120.676",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1665 122.482L57.4891 117.547",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2148 121.994L69.1508 123.317",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0225 125.123L67.3451 120.187",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0732 124.636L79.0089 125.958",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8799 127.765L77.2024 122.829",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1206 117.535L65.0565 118.858",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9277 120.665L63.2503 115.729",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9775 120.177L74.9134 121.499",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7842 123.306L73.1068 118.37",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6704 118.971L68.993 114.035",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7217 118.484L80.6573 119.807",
    stroke: "#808080",
    strokeWidth: 0.592405
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5278 121.613L78.8504 116.677",
    stroke: "#808080",
    strokeWidth: 0.592405
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2976 128.103C40.5936 134.463 45.5754 155.875 46.1475 158.293C46.3307 159.072 46.9309 159.685 47.6998 159.894C48.2704 160.047 48.86 159.963 49.3536 159.678C49.5345 159.574 49.7001 159.443 49.8505 159.286C51.5549 157.478 66.5742 141.425 68.2782 135.065C70.1972 127.903 65.9307 120.513 58.7683 118.594C51.6022 116.676 44.2187 120.944 42.2976 128.103Z",
    fill: "#E0E0E0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4937 156.943C49.9486 155.384 53.5128 151.511 57.0707 147.227C59.1374 144.738 61.1737 142.145 62.7862 139.807C64.4579 137.383 65.4756 135.511 65.7747 134.394C67.3232 128.615 63.8777 122.647 58.0985 121.097C52.3155 119.55 46.352 122.997 44.8011 128.774C44.801 128.774 44.8009 128.774 44.8009 128.774C44.8008 128.775 44.8008 128.775 44.8008 128.775C44.5019 129.891 44.4473 132.021 44.6832 134.956C44.9109 137.787 45.3779 141.051 45.9236 144.239C46.8631 149.729 48.0132 154.866 48.4937 156.943ZM42.2976 128.103C44.2187 120.944 51.6022 116.676 58.7683 118.594C65.9307 120.513 70.1972 127.903 68.2782 135.065C66.5742 141.425 51.5549 157.478 49.8505 159.286C49.7001 159.443 49.5345 159.574 49.3536 159.678C48.86 159.963 48.2704 160.047 47.6998 159.894C46.9309 159.685 46.3307 159.072 46.1475 158.293C45.5754 155.875 40.5936 134.463 42.2976 128.103Z",
    fill: "#808080"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7488 92.4452L63.9533 52.5298L78.0469 44.6601L90.4349 72.6438L103.638 66.3961L111.229 106.832L123.944 102.38L120.481 166.231L111.96 119.758L101.465 125.263L91.1879 85.9609L80.7488 92.4452Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5753 43.0787L90.9958 71.1359L104.473 64.7584L112.092 105.34L125.156 100.766L121.603 166.292L119.377 166.434L111.13 121.461L100.736 126.913L90.4868 87.7186L80.2241 94.0934L62.5286 52.039L78.5753 43.0787ZM65.3785 53.0204L81.274 90.7969L91.8893 84.2032L102.195 123.612L112.789 118.054L119.874 156.692L122.732 103.995L110.366 108.324L102.803 68.0338L89.8743 74.1515L77.5189 46.2413L65.3785 53.0204Z",
    fill: "#808080"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/gray-star.56b07ec579917f89d522cb1b51a3a9de.svg";
export { ForwardRef as ReactComponent };